import { z } from 'zod';
import type { InspectorToken } from '@sleed/bizcommerce-api';

/**
 * Inspector edit form. Mirrors `InspectorToken` and the legacy admin grid
 * (Core/client/admin/src/pages/Customers/Inspectors/index.js): fn/ln required ≤50,
 * eml ≤255, tel/mob ≤20, iv visible flag, si sort.
 */
export const inspectorSchema = z.object({
	id: z.number().optional(),
	fn: z.string().trim().min(1, 'validation.required').max(50, 'validation.tooLong'),
	ln: z.string().trim().min(1, 'validation.required').max(50, 'validation.tooLong'),
	eml: z.string().trim().max(255, 'validation.tooLong').nullable(),
	tel: z.string().trim().max(20, 'validation.tooLong').nullable(),
	mob: z.string().trim().max(20, 'validation.tooLong').nullable(),
	iv: z.boolean(),
	si: z.number().int()
});

export type InspectorFormValues = z.infer<typeof inspectorSchema>;

export const EMPTY_INSPECTOR: InspectorFormValues = {
	fn: '',
	ln: '',
	eml: '',
	tel: '',
	mob: '',
	iv: true,
	si: 0
};

export function tokenToForm(token: InspectorToken): InspectorFormValues {
	return {
		id: token.id,
		fn: token.fn ?? '',
		ln: token.ln ?? '',
		eml: token.eml ?? '',
		tel: token.tel ?? '',
		mob: token.mob ?? '',
		iv: token.iv ?? true,
		si: token.si ?? 0
	};
}

export function formToToken(form: InspectorFormValues, original: InspectorToken | null): InspectorToken {
	return {
		...(original ?? {}),
		id: form.id,
		fn: form.fn.trim(),
		ln: form.ln.trim(),
		eml: form.eml?.trim() || null,
		tel: form.tel?.trim() || null,
		mob: form.mob?.trim() || null,
		iv: form.iv,
		si: form.si
	};
}
